import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import store from '@/store'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  // 'resetChannels',
  // 'resetMessages',
  // 'getChatChannels',
  // 'getMessages',
  // 'updateChatChannel',
  // 'deleteChannels'

  resetChannels({ commit }) {
    commit(types.RESET_CHANNELS)
  },
  resetMessages({ commit }) {
    commit(types.RESET_MESSAGES)
  },
  async getChannels({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getChannels', () =>
      http.get('chat/allchannels', {
        params: searchOptions
      })
    )
    commit(types.SET_CHANNELS, r.data)
    return r.data
  },
  // subscribe({ commit, state }, firm) {
  //   let pubnub = store.getters['chat/pubnub']
  //   pubnub.subscribe({
  //     channelGroups: [firm.toString()],
  //     withPresence: true
  //   })
  // },
  getChannelInfo({ commit }, data) {
    return store.dispatch('chat/getChannelInfo', data)
  },
  async getMessages({ commit, dispatch }, data) {
    if (data.active) {
      console.log('ChatAdmin: getting Chat Messages', data)
      let results = await store.dispatch('chat/getChannelMessages', data)
      console.log('ChatAdmin: got Chat Messages', results)
      commit(types.SET_CHATMESSAGES, results)
      return results
    } else {
      const r = await startLoading(dispatch, 'getMessages', () =>
        http.get(`chat/messages?id=${data.channelId}`)
      )
      commit(types.SET_CHATMESSAGES, r.data)
      return r.data
    }
  },
  async deleteChannels({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteChannels', () =>
      http.post('chat/deleteChannels', data)
    )
    return r.data
  },
  async getChatChannels({ commit, dispatch }, data) {
    let url = `chat/channels?pageSize=${data.pageSize}`
    if (data.lastFetchTime !== null) {
      url += `&lastFetchTime=${data.lastFetchTime}`
    }
    const r = await startLoading(dispatch, 'getChatGroups', () => http.get(url))
    commit(types.SET_CHATGROUPS, r.data)
    return r.data
  },
  async getChatGroups({ commit, dispatch }, data) {
    let url = `chat/groups?pageSize=${data.pageSize}`
    if (data.lastFetchTime !== null) {
      url += `&lastFetchTime=${data.lastFetchTime}`
    }
    const r = await startLoading(dispatch, 'getChatGroups', () => http.get(url))
    commit(types.SET_CHATGROUPS, r.data)
    return r.data
  },
  async getChatGroup({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getChatGroup', () =>
      http.get(`chat/groupInfo?id=${id}`)
    )
    commit(types.SET_CHATGROUP, r.data)
    return r.data
  },
  async getChatMessages({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getChatMessages', () =>
      http.get(`chat/groupMessages?id=${id}`)
    )
    commit(types.SET_CHATMESSAGES, r.data)
    return r.data
  },
  async deleteChatGroups({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteChatGroup', () =>
      http.post('chat/deleteGroups', data)
    )
    return r.data
  },
  updateChatGroup({ commit }, data) {
    commit(types.UPDATE_CHATGROUP, data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/actions.js